
import ReviewsCommentAttachmentFile from '~/components/catalog/reviews/Comment/Attachment/File';
import ReviewsCommentAttachmentImage from '~/components/catalog/reviews/Comment/Attachment/Image';

export default {
  name: 'ReviewsCommentAttachment',
  components: {ReviewsCommentAttachmentImage, ReviewsCommentAttachmentFile},
  props: {
    files: {
      type: Array,
      required: true,
    },
  },
  computed: {
    imageFiles() {
      return this.files.filter(this.isImageFile)
    },
    otherFiles() {
      return this.files.filter(file => !this.isImageFile(file))
    },
  },
  methods: {
    isImageFile(file) {
      return file.content_type?.startsWith('image/')
    },
  },
}
